import "./destination-selector-modal.scss";

import { ChipGroup, Button } from "../../../components";
import { useTranslate } from "../../../features/translation/hooks/use-translation";

const DestinationSelectorModal = ({
  sortedOptions,
  categories,
  disableCategories,
  disableDestinations,
  renderContinent,
  toggleCategory,
  onClose,
  onReset,
  isOpen,
}) => {
  const { t } = useTranslate();

  return (
    <div className="input-modal" style={{ overflowAnchor: "none !important" }}>
      <div
        className="input-modal--backdrop"
        hidden={!isOpen}
        onClick={onClose}
      />

      <div style={{ paddingLeft: "calc(50% - 0.75rem)" }} hidden={!isOpen}>
        <div className="input-modal--arrow" />
      </div>

      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          marginTop: "12px",
        }}
        hidden={!isOpen}
      >
        <dialog className="input-dialog base" aria-modal="true" open={isOpen}>
          <form method="dialog" className="input-modal--content">
            <header className="content-header">
              <span className="title">
                <p className="text lead medium semibold nospace">
                  {t("input.custom.hiddenDestinationSelector.label")}
                </p>
              </span>

              <span className="control">
                <button
                  className="icon-button primary medium"
                  type="button"
                  onClick={onClose}
                >
                  <span
                    className="icon"
                    style={{
                      WebkitMaskImage:
                        "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)",
                      maskImage:
                        "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)",
                    }}
                  />
                </button>
              </span>
            </header>

            <section className="main">
              <div className="container">
                <div className="row">
                  {/* Category menu */}
                  <div className="quickMenu col col-12 ">
                    <label
                      className={`text lead medium ${
                        disableCategories ? "disabled" : ""
                      }`}
                    >
                      {t(
                        "input.custom.hiddenDestinationSelector.titleCategories"
                      )}
                    </label>

                    <ChipGroup
                      className="choice"
                      name="destination-categories"
                      values={categories}
                      disabled={disableCategories}
                      options={[
                        {
                          label: t(
                            "input.custom.hiddenDestinationSelector.beach"
                          ),
                          value: "beach",
                          icon: "sun",
                        },
                        {
                          label: t(
                            "input.custom.hiddenDestinationSelector.city"
                          ),
                          value: "city",
                          icon: "city",
                        },
                        {
                          label: t(
                            "input.custom.hiddenDestinationSelector.exotic"
                          ),
                          value: "exotic",
                          icons: ["aircraft-distance", "desert-island"],
                        },
                        {
                          label: t(
                            "input.custom.hiddenDestinationSelector.ski"
                          ),
                          value: "ski",
                          icon: "ski-mountain",
                        },
                      ]}
                      onChange={(value, checked) =>
                        toggleCategory(value, checked)
                      }
                    />
                  </div>
                </div>

                {/* Country Menu */}
                <div className="fullMenu">
<label className={`text lead medium ${disableDestinations ? "disabled-block" : ""}`}>
                    {t("input.custom.hiddenDestinationSelector.titleCountries")}
                  </label>
                  <div className="row">
                    <div className="col col-12 col-md-6 col-lg-4">
                      {renderContinent(
                        "europe",
                        sortedOptions.europe.slice(0, 18),
                        0
                      )}
                    </div>

                    <div className="col col-12 col-md-6 col-lg-4">
                      {renderContinent("", sortedOptions.europe.slice(18), 1)}
                      {renderContinent("asia", sortedOptions.asia, 2)}
                      {renderContinent(
                        "northAmerica",
                        sortedOptions.northAmerica,
                        4
                      )}
                    </div>

                    <div className="col col-12 col-md-6 col-lg-4">
                      {renderContinent(
                        "southAmerica",
                        sortedOptions.southAmerica,
                        5
                      )}
                      {renderContinent(
                        "africaMe",
                        [...sortedOptions.africaMiddleEast],
                        3
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <menu
              className="footer"
              style={{
                display: "flex",
                gap: "var(--space-4)",
                justifyContent: "flex-end",
              }}
            >
              {onReset && (
                <Button
                  label={t("input.button.reset")}
                  className="ghost medium"
                  onClick={onReset}
                  style={{ border: 0, textDecoration: "underline" }}
                />
              )}

              <Button
                label={t("input.button.close")}
                className="primary medium"
                onClick={onClose}
              />
            </menu>
          </form>
        </dialog>
      </div>
    </div>
  );
};

export default DestinationSelectorModal;
